(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('stud-footer-menus')) {
  customElements.define('stud-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.menus = [...this.querySelectorAll('.ss-footer-menu')];
      this.groupName = this.menus[0]?.getAttribute('name');
      this.mobile = matchMedia('(max-width: 740px)');
      this.sync = () => {
        this.menus.forEach(menu => menu.removeAttribute('name'));
        this.menus.forEach(menu => {
          const summary = menu.querySelector('summary');
          menu.open = !this.mobile.matches;
          if (this.mobile.matches) {
            if (this.groupName) menu.setAttribute('name', this.groupName);
            summary.removeAttribute('tabindex');
            summary.removeAttribute('aria-disabled');
          } else {
            summary.setAttribute('tabindex', '-1');
            summary.setAttribute('aria-disabled', 'true');
          }
        });
      };
      this.onSummaryClick = event => {
        if (!this.mobile.matches && event.target.closest('summary')) event.preventDefault();
      };
      this.addEventListener('click', this.onSummaryClick);
      this.mobile.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onSummaryClick);
      this.mobile.removeEventListener('change', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stud-date"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.sdReady) return;
    root.dataset.sdReady = 'true';
    const choices = [...root.querySelectorAll('[data-sd-choice]')];
    const select = button => {
      const kind = button.dataset.sdChoice;
      choices.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelectorAll('[data-sd-scope]').forEach(item => {
        item.hidden = !['all', kind].includes(item.dataset.sdScope);
      });
    };

    if (choices.length) {
      root.querySelector('[data-sd-choices]').hidden = false;
      choices.forEach(button => button.addEventListener('click', () => select(button)));
      select(choices[0]);
    }

    const carousel = root.querySelector('.sdate__carousel');
    if (carousel) {
      const previous = root.querySelector('[data-sd-prev]');
      const next = root.querySelector('[data-sd-next]');
      root.querySelector('[data-sd-controls]').hidden = false;

      const update = () => {
        previous.disabled = carousel.scrollLeft <= 2;
        next.disabled = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
      };

      const move = direction => {
        const card = carousel.querySelector('.sdate__piercing');
        if (!card) return;
        carousel.scrollBy({
          left: direction * (card.getBoundingClientRect().width + 16),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      carousel.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(carousel);
      update();
    }

    root.addEventListener('shopify:block:select', event => {
      const item = [...root.querySelectorAll('[data-sd-block]')].find(
        el => el.dataset.sdBlock === event.detail.blockId
      );
      if (!item) return;
      const scope = item.dataset.sdScope || item.dataset.sdChoice || item.closest('[data-sd-scope]')?.dataset.sdScope;
      const button = choices.find(el => el.dataset.sdChoice === scope);
      if (button) select(button);
      if (item.matches('details')) item.open = true;
      item.scrollIntoView({block:'nearest', inline:'nearest'});
    });
  };

  const boot = () => document.querySelectorAll('.sdate').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', event => {
    init(event.target.querySelector('.sdate'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
